import { Tag } from 'antd'
import { isValidArray } from '../../../utils/helpers'
import styles from '../../../testrun.module.css'

const TAG_COLORS = {
    epic: '#dbeafe',
    sprint: '#e0e7ff',
    tags: '#dcfce7',
    search: '#e0e7ff',
    project: '#f3e8ff',
}

const TAG_TEXT = {
    epic: '#1d4ed8',
    sprint: '#4338ca',
    tags: '#15803d',
    search: '#4338ca',
    project: '#7c3aed',
}

const ShowFilter = ({ data, onRemove }) => {
    const formatValue = (key, value) => {
        if (!value) return 'N/A'
        if (Array.isArray(value)) {
            if (value.length === 0) return 'N/A'
            return value.map((v) => v.label || v.title || v.name).join(', ')
        }
        if (typeof value === 'object') {
            return value.label || value.title || value.name || 'N/A'
        }
        return value
    }

    const renderTag = (key, label, value) => (
        <Tag
            key={key}
            className={styles.filterTag}
            closable={!!onRemove}
            onClose={(e) => {
                e.preventDefault()
                onRemove?.(key)
            }}
            style={{
                background: TAG_COLORS[key] || '#f1f5f9',
                color: TAG_TEXT[key] || '#475569',
            }}
        >
            <span className={styles.filterTagLabel}>{label}:</span>{' '}
            <span className={styles.filterTagValue}>
                {formatValue(key, value)}
            </span>
        </Tag>
    )

    return (
        <>
            {isValidArray(data?.epic) && renderTag('epic', 'Epic', data?.epic)}
            {data?.sprint && renderTag('sprint', 'Sprint', data?.sprint)}
            {isValidArray(data?.tags) && renderTag('tags', 'Tags', data?.tags)}
            {(data?.search?.title || data?.search?.testId) &&
                renderTag(
                    'search',
                    'Search',
                    data?.search?.title || data?.search?.testId
                )}
            {data?.project && renderTag('project', 'Project', data?.project)}
        </>
    )
}

export default ShowFilter
